<template>
  <div class="flex-col-center-start pt-6 gap-3">
    <v-card
      v-for="item in items"
      :key="item"
      outlined
      min-height="80px"
      class="w-100 px-4 py-2 direction-ltr flex-row-start-center gap-3"
    >
      <div class="prediction-result-title">
        {{ $t(item) }}
        <div v-if="errorRatesForInterval[item] !== undefined">
          <small>
            ({{ $t("error_rate") }}: %{{ errorRatesForInterval[item] }})
          </small>
        </div>
      </div>

      <v-text-field
        class="prediction-result"
        background-color="background"
        dense
        flat
        solo
        :suffix="`(${units[item]})`"
        :value="predictionResult[item]"
        readonly
        full-width
      />
    </v-card>
    <v-spacer></v-spacer>
    <v-btn
      color="infoGreen"
      class="white--text"
      min-width="300px"
      :disabled="!predictionResult.id"
      :loading="loading"
      @click="onSave"
    >
      {{ $t("save") }}
    </v-btn>
  </div>
</template>

<script>
import { SET_ALERT } from "@/core/services/store/modules/alert/alert.module";
import { SAVE_HMI_OPERATION } from "@/core/services/store/modules/hmi/hmi.module";
import { mapGetters } from "vuex";
import { RECOMMENDATION_UNIT } from "@/core/constants";

export default {
  name: "PredictionResults",

  props: {
    interval: { type: Number, required: true },
  },

  data() {
    return {
      loading: false,
      items: ["carbon", "metallization"],
      units: RECOMMENDATION_UNIT,
    };
  },

  computed: {
    ...mapGetters(["predictionResult", "errorRates"]),
    errorRatesForInterval() {
      if (!this.errorRates || !this.interval) return {};
      return {
        carbon: this.errorRates[`error_rate_carbon_${this.interval}h`],
        metallization: this.errorRates[`error_rate_metal_${this.interval}h`],
      };
    },
  },

  methods: {
    async onSave() {
      this.loading = true;
      await this.$store
        .dispatch(SAVE_HMI_OPERATION, {
          operationId: this.predictionResult.id,
          type: "prediction",
        })
        .then(() => {
          this.$store.commit(SET_ALERT, {
            text: this.$t("saveMessage"),
            isError: false,
          });
        })
        .catch((error) => {
          this.$store.commit(SET_ALERT, {
            text: error.message,
            isError: true,
          });
        });
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.prediction-result-title {
  font-size: 16px;
  font-weight: 500;
  min-width: 150px;
}
.prediction-result {
  & .v-text-field__details {
    display: none;
  }
}
</style>
